import { useMediaQuery } from "@mui/material";
import { usePostHog } from "posthog-js/react";
import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { openEmployerSignUp } from "../../../helpers/elp_sign_up";
import { sendTrackingEvent } from "../../../helpers/tracking_management";
import { fetchEmployerContactCard } from "../../../redux/actions/company_action";
import { showInfoDialog } from "../../../redux/actions/dialog_action";
import content_my from "./content_my.json";
import content_sg from "./content_sg.json";
import {
  BoxStyled,
  ButtonStyled,
  CardStyled,
  SectionContainer,
  TextStyled,
} from "./styles";

function EmployerLandingContactUs() {
  const [contactCard, setContactCard] = useState([]);
  const isDesktop = useMediaQuery("(max-width:1280px)");
  const isTablet = useMediaQuery("(max-width:768px)");
  const dispatch = useDispatch();

  const posthog = usePostHog();
  const buttonCTA = "Post Jobs Now";
  const buttonColour = "yellow";

  function triggerInfoDialog() {
    // dispatch(
    //   updateContactUsEmployer({ state: true, origin: "contact-us-banner" })
    // );

    sendTrackingEvent({
      event: "CE_contact-us-foot-banner",
    });

    posthog.capture(
      //posthog tracking (Request a Call button) [JSW-3048]
      "elp_contact_us_click",
      {
        section: "footer",
        cta: "Request a Call",
        colour: buttonColour,
      }
    );

    openEmployerSignUp({
      posthog,
      buttonCTA: buttonCTA,
      buttonColour: buttonColour,
      section: "footer",
    });
  }

  async function fetchData() {
    const responseApi = await dispatch(fetchEmployerContactCard());

    const isMalaysia = process.env.NEXT_PUBLIC_JSW_GEOLOCATION === "my";
    const response = isMalaysia ? content_my : content_sg;

    const { contactCard } = response || {};

    setContactCard(contactCard);
  }

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <SectionContainer>
      <CardStyled>
        <BoxStyled
          display={"flex"}
          flexDirection={"column"}
          alignItems={"flex-start"}
          gap={"16px"}
          width={"100%"}
          alignSelf={"stretch"}
          maxWidth={!(isDesktop || isTablet) ? "740px" : "unset"}
        >
          <TextStyled
            color={"#512ACC"}
            fontFamily={"Georgia"}
            fontSize={isDesktop ? "32px" : "40px"}
            fontWeight={400}
            lineHeight={isTablet ? "41.6px" : isDesktop ? "38.4px" : "48px"}
            dangerouslySetInnerHTML={{
              __html: contactCard?.title,
            }}
          >
            {/* Looking for a customised solution?{" "}
            {!(isDesktop || isTablet) && <br />}
            Get in touch today. */}
          </TextStyled>

          <TextStyled
            color={"#512ACC"}
            fontFamily={"Inter"}
            fontSize={isTablet ? "16px" : isDesktop ? "18px" : "20px"}
            fontWeight={400}
            lineHeight={isTablet ? "22.4px" : isDesktop ? "21.6px" : "24px"}
          >
            {contactCard?.description}
          </TextStyled>
        </BoxStyled>
        <ButtonStyled onClick={triggerInfoDialog}>Post Jobs Now</ButtonStyled>
      </CardStyled>
    </SectionContainer>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    showInfoDialog: bindActionCreators(showInfoDialog, dispatch),
  };
};

export default connect(null, mapDispatchToProps)(EmployerLandingContactUs);
